import React, { useEffect, useState } from 'react';
import './style.css';
import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import http from '../../services/http-service'
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import 'react-toastify/dist/ReactToastify.css';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { getErrorResponse } from '../../utils';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from '@mui/material/Checkbox';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Moment from 'moment';
import { useStyles } from "./utils";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { StaticDateTimePicker } from '@mui/x-date-pickers/StaticDateTimePicker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 300
        }
    },
    // getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};


const theme = createTheme();

export default function PriceManagemantAddEdit(props) {
    const classes = useStyles();
    const history = useHistory();
    const [tableRow, setTableRow] = useState([])
    // eslint-disable-next-line
    const [open, setOpen] = useState(false);
    const [companyList, setCompanyList] = useState([]);
    const [rowsData, setRowsData] = useState([]);
    const [selected, setSelected] = useState([]);
    const isAllSelected = companyList.length > 0 && selected.length === companyList.length;


    useEffect(() => {
        getCompanyList();
        // eslint-disable-next-line
    }, []);


    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    const goBack = () => {
        history.goBack()
    }

    const addTableRows = () => {
        const rowsInput = {
            mode: '',
            selectAll: false,
            lower_limit: '',
            uper_limit: '',
            transaction_fees: '',
            promotion_fees: '',
            promotion_start: '',
            promotion_end: '',
            promotion_target: [],
            promotion: false
        }
        setRowsData([...rowsData, rowsInput])
    }

    const handleRemoveRow = (index) => {
        const rows = [...rowsData];
        rows.splice(index, 1);
        setRowsData(rows);
    }

    const getPromotionData = (list) => {
        handleToggle()
        http('admin/pricemanagement_setting/', 'GET', '', { price_type: props.priceType })
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    if (res.data.length > 0) {
                        res.data.forEach(elem => {
                            elem.promotion_target = setPromotionTargetValue(list, elem.promotion_target);
                            if (elem.promotion_target.length === list.length)
                                elem['selectAll'] = true
                            else
                                elem['selectAll'] = false
                        })
                        // console.log('res.data....',res.data)
                        // setTableRows(res.data)
                        setRowsData(res.data)
                    } else {
                        let arr = []
                        let obj = {
                            mode: '',
                            // band: 1,
                            selectAll: false,
                            lower_limit: '',
                            uper_limit: '',
                            transaction_fees: '',
                            promotion_fees: '',
                            promotion_start: '',
                            promotion_end: '',
                            promotion_target: [],
                            promotion: false
                        }
                        arr.push(obj)
                        setRowsData(arr)
                    }
                }
                else {
                    const error = getErrorResponse(res.message)
                    toast.error(error, { toastId: "error", allowHtml: true })
                }
                handleClose()
            })
            .catch(error => {
                toast.error("Something went wrong!",{
                    toastId: "error"
                })
                handleClose()
            });
    }

    const handleSubmit = (event) => {
        let postData = []
        rowsData.forEach((elem, index) => {
            if (elem.promotion) {
                if ((elem.mode === true || elem.mode === false) && elem.lower_limit && elem.uper_limit && elem.transaction_fees && elem.promotion_fees && elem.promotion_start && elem.promotion_end && elem.promotion_target.length > 0) {
                    postData.push(setObj(elem, index))
                }
            } else {
                if ((elem.mode === true || elem.mode === false) && elem.lower_limit && elem.uper_limit && elem.transaction_fees) {

                    postData.push(setObj(elem, index))
                }
            }

        })

        if (rowsData.length !== postData.length) {
            toast.error("Please fill all the fields or Remove row",{
                toastId: 'blank_fields_error',
            })
            return;
        }

        if (postData.length === 0)
            return
        // return
        handleToggle()
        http('admin/pricemanagement_setting/', 'POST', { price_type: props.priceType, promotion_data: postData })
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    getPromotionData(companyList)
                    toast.success(res.message,{
                        toastId: 'request_success'
                    })
                }
                else {
                    toast.error(res.message,{
                        toastId: 'request_failed'
                    })
                }
                handleClose()
            })
            .catch(error => {
                toast.error("Something went wrong!",{
                    toastId: 'error'
                })
                handleClose()
            });
    };

    const setObj = (elem, index) => {
        let obj = {
            mode: elem.mode,
            band: index + 1,
            price_type: 'Now',
            lower_limit: elem.lower_limit,
            uper_limit: elem.uper_limit,
            transaction_fees: elem.transaction_fees,
            promotion_fees: elem.promotion_fees,
            promotion_start: elem.promotion_start,
            promotion_end: elem.promotion_end,
            promotion: elem.promotion,
            promotion_target: setPromotionTargetKeys(elem.promotion_target)
        }
        return obj;
    }

    const setPromotionTargetValue = (list, arr) => {
        let response = list.filter(item => arr.includes(item.user));
        return response.map(function (value) { return value.display });
    }
    const setPromotionTargetKeys = (arr) => {
        let response = companyList.filter(item => arr.includes(item.display));
        return response.map(function (value) { return value.user });
    }

    const getCompanyList = () => {
        handleToggle()
        http('admin/company_list/', 'GET')
            .then(res => {
                if (res.data.status) {
                    let array = []
                    if (Array.isArray(res.data.data))
                        array = res.data.data
                    else {
                        array.push(res.data.data)
                    }
                    array.forEach(elem => {
                        elem['display'] = elem.name + '(' + elem.employer_id + ')'
                    })
                    setCompanyList(array)
                    getPromotionData(array);
                }
                else {
                    toast.error(res.data.message,{
                        toastId: 'request_failed'
                    })
                }
                handleClose()
            },
                err => {
                    handleClose()
                    console.log('err....', err)
                })
    }


    const preventMinus = (e) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    const preventKeyDown = (e) => {
        if (e.code === 'ArrowDown') {
            e.preventDefault();
        }
    }

    return (
        <div className=''>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className=''>
                    <div className='pricingDiv'>
                        <TableContainer component={Paper}>
                            <Table aria-label="customized table">
                                <thead>
                                    <tr>
                                        <th>Mode</th>
                                        <th >Band</th>
                                        <th >Lower Limit</th>
                                        <th >Upper Limit</th>
                                        <th >Transaction Fee</th>
                                        <th >Promotion Fee</th>
                                        <th >Promotion Start</th>
                                        <th >Promotion End</th>
                                        <th >Promotion Target</th>
                                        <th > Promotion </th>
                                        <th > Action </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rowsData.map((row, idx) => (
                                        <tr key={idx}>
                                            <td>
                                                <FormControl fullWidth>
                                                    <RadioGroup
                                                        aria-labelledby="demo-radio-buttons-group-label"
                                                        name="radio-buttons-group"
                                                    >
                                                        <FormControlLabel name='mode' checked={row.mode === true} value="true" control={<Radio />} label="active" onChange={(e) => {
                                                            rowsData[idx].mode = true
                                                            setTableRow(rowsData.map((obj, i) => i === idx ? rowsData[idx] : obj))
                                                        }} />
                                                        <FormControlLabel name='mode' checked={row.mode === false} value="false" control={<Radio />} label="inactive" onChange={(e) => {
                                                            rowsData[idx].mode = false
                                                            setTableRow(rowsData.map((obj, i) => i === idx ? rowsData[idx] : obj))
                                                        }} />
                                                    </RadioGroup>
                                                </FormControl>
                                            </td>
                                            <td >{idx + 1}</td>
                                            <td >
                                                <Box component="form" noValidate autoComplete="off">
                                                    <TextField inputProps={{ type: "number" }} onKeyDown={preventKeyDown} onKeyPress={preventMinus} name='lowerlimit' value={row.lower_limit} min= "0" id="lowerlimit" label="Lower Limit" variant="outlined" onChange={(e) => {
                                                        rowsData[idx].lower_limit = e.target.value
                                                        setTableRow(rowsData.map((obj, i) => i === idx ? rowsData[idx] : obj))
                                                    }} />
                                                </Box>
                                            </td>
                                            <td >
                                                <Box component="form" noValidate autoComplete="off">
                                                    <TextField inputProps={{ type: "number" }} onKeyDown={preventKeyDown} onKeyPress={preventMinus} name='upperlimit' id="upperlimit" value={row.uper_limit} min= "0" label="Upper Limit" variant="outlined" onChange={(e) => {
                                                        rowsData[idx].uper_limit = e.target.value
                                                        setTableRow(rowsData.map((obj, i) => i === idx ? rowsData[idx] : obj))
                                                    }} />
                                                </Box>
                                            </td>
                                            <td >
                                                <Box component="form" noValidate autoComplete="off">
                                                    <TextField inputProps={{ type: "number" }} onKeyDown={preventKeyDown} onKeyPress={preventMinus} name='transaction_fees' id="outlined-basic" value={row.transaction_fees} min= "0" label="Transaction Fee" variant="outlined" onChange={(e) => {
                                                        rowsData[idx].transaction_fees = e.target.value
                                                        setTableRow(rowsData.map((obj, i) => i === idx ? rowsData[idx] : obj))
                                                    }} />
                                                </Box>
                                            </td>
                                            <td >
                                                <Box component="form" noValidate autoComplete="off">
                                                    <TextField inputProps={{ type: "number" }} disabled={!rowsData[idx].promotion} onKeyDown={preventKeyDown} onKeyPress={preventMinus} name='promotionFee' id="outlined-basic" value={row.promotion_fees} min= "0" label="Promotion Fee" variant="outlined" onChange={(e) => {
                                                        rowsData[idx].promotion_fees = e.target.value
                                                        setTableRow(rowsData.map((obj, i) => i === idx ? rowsData[idx] : obj))
                                                    }} />
                                                </Box>
                                            </td>
                                            <td className='tableMaxWidth'>
                                                {console.log(row , 'row data')}
                                               
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                               
                                                  <MobileDateTimePicker inputProps={{ type: "text", readOnly: true }} disabled={!rowsData[idx].promotion} label="Enter promotion start date"
                                                        name='promotionStart' id="promotionStart"   value={ Moment( row.promotion_start)._d} maxDate={row.promotion_end ? new Date(row.promotion_end) :  null} minDate= {new Date()}
                                                        renderInput={(params) => <TextField className='muiError' value={row.promotion_start} InputLabelProps={{ shrink: true }} name='promotionStart' id="promotionStart" inputProps={{ type: "text" }} {...params} />}
                                                        onChange={(date) => {
                                                            if (date) {
                                                                rowsData[idx].promotion_start = Moment(date).format()
                                                                setTableRow(rowsData.map((obj, i) => i === idx ? rowsData[idx] : obj))
                                                            }

                                                        }}
                                                    />   
                                                </LocalizationProvider>
                                            </td>
                                            <td className='tableMaxWidth'>
                                                {/* {console.log(Moment(row.promotion_start)._d ,'date')} */}
                                                <LocalizationProvider dateAdapter={AdapterDateFns} sx={{ border: '1px solid #ddd !important' }}>
                                                    <MobileDateTimePicker inputProps={{ type: "text", readOnly: true }} disabled={!rowsData[idx].promotion} label="Enter promotion end date"
                                                      
                                                        name='promotionEnd' id="promotionEnd"   value={Moment(row.promotion_end)._d } minDateTime={row.promotion_start ? new Date(row.promotion_start)  : new Date()}
                                                        renderInput={(params) => <TextField className='muiError' InputLabelProps={{ shrink: true }} name='promotionEnd' id="promotionEnd" inputProps={{ type: "text" }} {...params} />}
                                                        onChange={(date) => {
                                                            if (date) {
                                                                rowsData[idx].promotion_end = Moment(date).format()
                                                                setTableRow(rowsData.map((obj, i) => i === idx ? rowsData[idx] : obj))
                                                            }

                                                        }}
                                                    />
 
                                                </LocalizationProvider>
                                            </td>
                                            <td className=''>
                                                <div>
                                                    <FormControl sx={{ m: 1, width: 300 }}>
                                                        <InputLabel id="demo-multiple-checkbox-label">Promotion Target</InputLabel>
                                                        <Select name="promotionTarget" multiple labelId="demo-multiple-checkbox-label"  id="demo-multiple-checkbox" value={row.promotion_target} onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (value[value.length - 1] === "all") {
                                                                rowsData[idx].selectAll = !rowsData[idx].selectAll;
                                                                let arr = []
                                                                companyList.forEach(elem => {
                                                                    arr.push(elem.display)
                                                                })
                                                                if (selected.length === companyList.length) {
                                                                    setSelected([])
                                                                    rowsData[idx].selectAll = false;
                                                                    rowsData[idx].promotion_target = []
                                                                } else {
                                                                    setSelected(arr)
                                                                    rowsData[idx].selectAll = true;
                                                                    rowsData[idx].promotion_target = arr
                                                                }
                                                                setTableRow(rowsData.map((obj, i) => i === idx ? rowsData[idx] : obj))
                                                                return;
                                                            }
                                                            setSelected(value)
                                                            rowsData[idx].promotion_target = e.target.value
                                                            setTableRow(rowsData.map((obj, i) => i === idx ? rowsData[idx] : obj))
                                                        }} input={<OutlinedInput label="Promotion Target" />} renderValue={(selected) => selected.join(', ')} MenuProps={MenuProps}
                                                        >
                                                            <MenuItem value="all" classes={{ root: isAllSelected ? classes.selectedAll : "" }} >
                                                                <ListItemIcon>
                                                                    <Checkbox
                                                                        classes={{ indeterminate: classes.indeterminateColor }}
                                                                        checked={rowsData[idx].selectAll}
                                                                        indeterminate={
                                                                            selected.length > 0 && selected.length < companyList.length
                                                                        }
                                                                    />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    classes={{ primary: classes.selectAllText }}
                                                                    primary="Select All"
                                                                />
                                                            </MenuItem>
                                                            {companyList.map((obj) => (
                                                                <MenuItem key={obj.display} value={obj.display}>
                                                                    <Checkbox checked={row.promotion_target.indexOf(obj.display) > -1} />
                                                                    <ListItemText primary={obj.display} />
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </td>
                                            <td >
                                                <Box className='text-center'>
                                                    <span className='promotionGrennText'>Promotion</span>
                                                    <FormControlLabel name="promotion" control={<Switch checked={row.promotion}
                                                        onChange={(e) => {
                                                            rowsData[idx].promotion = !rowsData[idx].promotion
                                                            setTableRow(rowsData.map((obj, i) => i === idx ? rowsData[idx] : obj))
                                                        }}
                                                    />} />
                                                </Box>
                                            </td>
                                            <td className=''>
                                                {
                                                    rowsData.length - 1 === idx ? (<AddIcon className='cursorStyle' onClick={addTableRows} />) : ""
                                                }

                                                {
                                                    rowsData.length - 1 === idx && idx > 0 ? (<DeleteIcon className='cursorStyle' onClick={() => handleRemoveRow(idx)} />) : ""
                                                }

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </TableContainer>
                    </div>

                    <div className='btnDiv'>
                        <Grid container className='justifyEnd' sx={{ justifyContent: 'flex-end' }}>
                            <Grid item={true} xs={12} className='gridbtnSubmit'>
                                <button type='button' className='btnSubmit btnCancel' onClick={goBack}>Cancel</button>
                                <button type='submit' className='btnSubmit' onClick={handleSubmit}>Submit</button>
                            </Grid>
                        </Grid>
                    </div>


                </div>

                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
                    <CircularProgress color="inherit" />
                </Backdrop>

            </ThemeProvider>
        </div>

    );
}